import { Link } from "react-router-dom";
import styled from "styled-components";
import { BsArrowLeft } from "react-icons/bs";
import InvestorStatusBadge from "./InvestorStatusBadge";

const Shell = styled.div`
  max-width: ${(p) => {
    if (p.$narrow) return "720px";
    if (p.$wide) return "none";
    return "100%";
  }};
  margin: 0 auto;
  padding-bottom: ${(p) => (p.$wide ? "0" : "0.5rem")};
  width: 100%;
  min-width: 0;

  .page-header {
    margin-bottom: 1.5rem;

    @media (min-width: 768px) {
      margin-bottom: 1.75rem;
    }
  }

  .page-title {
    color: #383838;
    font-weight: 600;
    font-size: clamp(1.35rem, 2.5vw, 1.75rem);
    margin-bottom: 0.5rem;
    line-height: 1.25;
  }

  .page-subtitle {
    color: #525252;
    font-size: 0.95rem;
    line-height: 1.55;
    margin-bottom: 0;
    max-width: 52rem;
  }

  .back-link {
    color: var(--color-secondary);
    font-size: 0.875rem;
    font-weight: 600;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    margin-bottom: 0.85rem;

    &:hover {
      color: color-mix(in srgb, var(--color-secondary) 85%, black);
    }
  }
`;

export default function InvestorPageShell({
  title,
  subtitle,
  backTo,
  backLabel = "Back to dashboard",
  status,
  statusLabel,
  action,
  children,
  className = "",
  wide = false,
  narrow = false,
}) {
  const resolvedBack = backTo === undefined ? null : backTo;

  return (
    <Shell className={`investor-page-shell ${className}`} $wide={wide} $narrow={narrow}>
      <header className="page-header">
        {resolvedBack ? (
          <Link to={resolvedBack} className="back-link">
            <BsArrowLeft size={16} aria-hidden />
            {backLabel}
          </Link>
        ) : null}

        <div className="d-flex flex-column flex-md-row align-items-md-start justify-content-between gap-3">
          <div className="flex-grow-1 min-w-0">
            {title ? (
              <div className="d-flex flex-wrap align-items-center gap-2 mb-1">
                <h1 className="page-title mb-0">{title}</h1>
                {status ? <InvestorStatusBadge status={status} label={statusLabel} /> : null}
              </div>
            ) : null}
            {subtitle ? <p className="page-subtitle">{subtitle}</p> : null}
          </div>
          {action ? <div className="flex-shrink-0">{action}</div> : null}
        </div>
      </header>
      {children}
    </Shell>
  );
}
